import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FilterPipe } from './pipes/filter.pipe';
import { DateFormatPipe } from './pipes/date-format.pipe';


@NgModule({
    imports: [
      CommonModule,
      FormsModule
    ],
    declarations: [ FilterPipe, DateFormatPipe ],
    exports: [ FilterPipe, DateFormatPipe ],
    providers: [ FilterPipe, DateFormatPipe ]
  })
  export class SharedModule {}